<template>
  <div class="common-card cursor-pointer mb-3">
    <slot></slot>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped lang="less">
@import "@/assets/common.less";
@import "@/styles/variables.less";

.common-card {
  width: 100%;
  position: relative;
  background-color: #ffffff;
  padding: 3vw 3vw;
  border-top-left-radius: 3vw;
  border-bottom-right-radius: 4.5vw;

  &::before {
    content: "";
    background: url("@{base-url}class_record/list_item_left_top_icon.png") no-repeat;
    height: 1.2rem;
    width: 1.2rem;
    background-size: contain;
    position: absolute;
    left: 0;
    top: 0;
  }

  &::after {
    content: "";
    background: url("@{base-url}class_record/list_item_right_bottom.png") no-repeat;
    height: 1.6rem;
    width: 1.6rem;
    background-size: contain;
    position: absolute;
    right: 0;
    bottom: 0;
  }
}
</style>
